import produce from "immer";

import names, {
    ClientPublicMarketResearchActionTypes,
} from "./clientPublicMarketResearchActionTypes";
import {
    ClientPublicMarketResearchState,
    defaultClientPublicMarketResearchState,
} from "./clientPublicMarketResearchState";

export const clientPublicMarketResearchReducer = (
    state: ClientPublicMarketResearchState,
    action: ClientPublicMarketResearchActionTypes
) =>
    produce(state, draft => {
        switch (action.type) {
            case names.PUBLIC_MARKET_RESEARCH: {
                draft = defaultClientPublicMarketResearchState;
                break;
            }

            case names.PUBLIC_MARKET_RESEARCH_SUCCESS: {
                break;
            }

            case names.PUBLIC_MARKET_RESEARCH_FAILURE: {
                break;
            }

            case names.PUBLIC_MARKET_RESEARCH_OVERVIEW: {
                draft.searchResults.overview = {
                    isBusy: true,
                };
                break;
            }

            case names.PUBLIC_MARKET_RESEARCH_OVERVIEW_SUCCESS: {
                draft.searchResults.overview = {
                    isBusy: false,
                    error: undefined,
                    data: action.payload.data,
                };
                break;
            }

            case names.PUBLIC_MARKET_RESEARCH_OVERVIEW_FAILURE: {
                draft.searchResults.overview = {
                    isBusy: false,
                    data: undefined,
                    error: action.payload.error,
                };
                break;
            }

            case names.PUBLIC_MARKET_RESEARCH_COMPENSATION: {
                draft.searchResults.compensation = {
                    isBusy: true,
                };
                break;
            }

            case names.PUBLIC_MARKET_RESEARCH_COMPENSATION_SUCCESS: {
                draft.searchResults.compensation = {
                    isBusy: false,
                    error: undefined,
                    data: action.payload.data,
                };
                break;
            }

            case names.PUBLIC_MARKET_RESEARCH_COMPENSATION_FAILURE: {
                draft.searchResults.compensation = {
                    isBusy: false,
                    data: undefined,
                    error: action.payload.error,
                };
                break;
            }

            case names.PUBLIC_MARKET_RESEARCH_SUPPLY_DEMAND: {
                draft.searchResults.supplyDemand = {
                    isBusy: true,
                };
                break;
            }

            case names.PUBLIC_MARKET_RESEARCH_SUPPLY_DEMAND_SUCCESS: {
                draft.searchResults.supplyDemand = {
                    data: action.payload.data,
                    isBusy: false,
                    error: undefined,
                };
                break;
            }

            case names.PUBLIC_MARKET_RESEARCH_SUPPLY_DEMAND_FAILURE: {
                draft.searchResults.supplyDemand = {
                    error: action.payload.error,
                    isBusy: false,
                    data: undefined,
                };
                break;
            }

            case names.PUBLIC_MARKET_RESEARCH_DIVERSITY: {
                draft.searchResults.diversity = {
                    isBusy: true,
                };
                break;
            }

            case names.PUBLIC_MARKET_RESEARCH_DIVERSITY_SUCCESS: {
                draft.searchResults.diversity = {
                    isBusy: false,
                    data: action.payload.data,
                };
                break;
            }

            case names.PUBLIC_MARKET_RESEARCH_DIVERSITY_FAILURE: {
                draft.searchResults.diversity = {
                    isBusy: false,
                    data: undefined,
                    error: action.payload.error,
                };
                break;
            }

            case names.PUBLIC_MARKET_RESEARCH_SUMMARY: {
                draft.searchResults.summary = {
                    isBusy: true,
                    data: undefined,
                    error: undefined,
                };
                break;
            }

            case names.PUBLIC_MARKET_RESEARCH_SUMMARY_SUCCESS: {
                draft.searchResults.summary = {
                    isBusy: false,
                    data: action.payload.data,
                    error: undefined,
                };
                break;
            }

            case names.PUBLIC_MARKET_RESEARCH_SUMMARY_FAILURE: {
                draft.searchResults.summary = {
                    isBusy: false,
                    data: undefined,
                    error: action.payload.error,
                };
                break;
            }
        }
    });
